<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Adicionar Integrante'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>

              <!-- Nome -->
              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label='Nome'
                    v-model="integrante.nome"
                    readonly
                    max-height="400"
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <!-- Vínculo -->
              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label='Vínculo'
                    :value="integrante.vinculo"
                    max-height="400"
                    readonly
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <!-- Função e Assessor -->
              <v-layout row wrap>

                <!-- Função -->
                <v-flex xs11 sm5>
                  <v-select
                    label='Função'
                    :items="listaFuncao"
                    v-model="integrante.funcao"
                    item-text="descricao"
                    item-value="item"
                    prepend-icon="dashboard"
                    max-height="400"
                    return-object
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>

                <v-spacer></v-spacer>

                <!-- Assessor -->
                <v-flex xs11 sm5 v-if="integrante.funcao.item !== 1">
                  <v-select
                    label='Assessor'
                    :items="listaAssessor"
                    v-model="integrante.assessor"
                    item-text="descricao"
                    item-value="item"
                    prepend-icon="dashboard"
                    max-height="400"
                    required
                    :disabled="projeto.assessor === true && administrador === false"
                    autocomplete >
                  </v-select>
                </v-flex>

                <!-- Assessor -->
                <v-flex xs11 sm5 v-if="integrante.funcao.item === 1">
                  <v-text-field
                    label='Assessor'
                    value="-"
                    disabled
                    max-height="400"
                    readonly
                    >
                  </v-text-field>
                </v-flex>

              </v-layout>

              <p class="mt-1"></p>

              <!-- Mensagem sobre assessor -->
              <v-layout row wrap justify-space-between v-if="integrante.assessor === true">
                <v-flex xs12>
                  <div class="center">
                    <v-card outlined>
                      <v-card-text class="black--text font-weight-bold">
                        O assessor deve ser um único integrante da equipe e terá apenas a permissão de preenchimento, não sendo autorizado a ele submeter para aprovação, excluir ou finalizar a ação.
                      </v-card-text>
                    </v-card>
                  </div>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <!-- Carga horária semanal e Escolaridade -->
              <v-layout row wrap>

                <!-- Carga horária semanal -->
                <v-flex xs11 sm5>
                  <v-text-field-integer
                    v-model="integrante.cargaHoraria"
                    label='Carga horária semanal'
                    :disabled="administrador !== true"
                    v-bind:properties="{
                      prependIcon: 'dashboard',
                      rules: numerico
                    }"
                  />
                </v-flex>

                <v-spacer></v-spacer>

                <!-- Escolaridade -->
                <v-flex xs11 sm5>
                  <v-select
                    label='Escolaridade'
                    :items="listaTitulacao"
                    v-model="integrante.titulacao"
                    item-text="descricao"
                    item-value="item"
                    prepend-icon="dashboard"
                    max-height="400"
                    return-object
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>

              </v-layout>

              <p class="mt-1"></p>

              <!-- Data inicial e Data final -->
              <v-layout row wrap>

                <!-- Data inicial -->
                <v-flex xs11 sm5>
                  <c-date-menu label="Data inicial" v-model="integrante.dataInicial" required :rules="regrasBasicas"></c-date-menu>
                </v-flex>

                <v-spacer></v-spacer>

                <!-- Data final -->
                <v-flex xs11 sm5 v-if="this.integrante.situacao !== 'A'">
                  <c-date-menu label="Data final" v-model="integrante.dataFinal" clearable></c-date-menu>
                </v-flex>
              </v-layout>

              <!-- Instituição que o membro da equipe representa -->
              <v-layout row wrap justify-space-between v-if="(integrante.vinculo === 'Externo' || integrante.vinculo === 'Aluno de pós-graduação')">
                <v-flex>
                  <v-text-field
                    label='Instituição que o membro da equipe representa'
                    v-model="integrante.instituicao"
                    counter="100"
                    required
                    :rules="regrasInstituicao"
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1" v-if="integrante.alunoPosUfes === 'N'"></p>

              <!-- Observação -->
              <v-layout row wrap justify-space-between>
                <v-flex>
                  <c-textarea :rows="2" :auto-grow="true"
                  label="Observação" v-model="integrante.obsParticipante"></c-textarea>
                </v-flex>
              </v-layout>

            </v-container>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Adicionar" -->
              <v-btn color="primary" text @click="adicionarIntegrante" :disabled="!formularioValido">Adicionar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idPessoa'],
    data: () => ({
      formularioValido: false,
      projeto: {},
      pessoa: {},
      integrante: {
        idPessoa: '',
        dataInicial: '',
        cargaHoraria: 0,
        funcao: '',
        titulacao: '',
        situacao: 'A',
        assessor: false,
        instituicao: '',
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [
        { 'item': true, 'descricao': 'Sim' },
        { 'item': false, 'descricao': 'Não' }
      ],
      numerico: [
        (input) => input !== undefined && input !== null && input !== '' || 'Este campo é obrigatório',
        (input) => !isNaN(input) || 'A carga horária deve ser numérica',
        (input) => (input.length === 0 || Number(input) >= 0) || 'A carga horária não pode ser negativa'
      ],
      regrasInstituicao: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres'
      ],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      // Adiciona um integrante.
      adicionarIntegrante () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' })
        projetos.postIntegrante(this.$props.idProjeto, this.integrante)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: 'Integrante adicionado com sucesso!'})
          this.$router.push({name: 'IntegrantesProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          console.log('Erro ao mandar a requisição' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' })
        })
      },

      // Carrega uma tabela estruturada.
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        return projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      }
    },
    mounted () {
      // Carrega lista de funções para um membro da equipe.
      this.opcoesTabelaEstruturada(6003, this, 'listaFuncao')
      .then(() => {
        // exclui o item 21 (discente-coordenador)
        this.listaFuncao = this.listaFuncao.filter(
          (item) => item.item !== 21
        )
      })

      // Carrega lista de escolaridade.
      this.opcoesTabelaEstruturada(168, this, 'listaTitulacao')

      // Carrega a ação de extensão.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        // Preenche dados da ação de extensão.
        this.projeto = response.data

        // Preenche dado inicial do integrante.
        this.integrante.dataInicial = this.projeto.dataInicio
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      // Carrega a pessoa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' })
      projetos.getPessoa(this.idPessoa)
      .then(response => {
        // Preenche dados da pessoa.
        this.pessoa = response.data

        // Preenche dados iniciais do integrante.
        this.integrante.idPessoa = this.pessoa.idPessoa
        this.integrante.nome = this.pessoa.nomeSocial
        this.integrante.vinculo = this.pessoa.vinculo
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// adicionar-integrante.vue?0ef6792e